import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { GlassCard } from '../UI/GlassCard';

export const AboutUs = () => {
  const { t } = useLanguage();

  const values = [
    {
      icon: 'fa-solid fa-shield-halved',
      title: t('about.value1.title'),
      desc: t('about.value1.desc')
    },
    {
      icon: 'fa-solid fa-headset',
      title: t('about.value2.title'),
      desc: t('about.value2.desc')
    },
    {
      icon: 'fa-solid fa-rocket',
      title: t('about.value3.title'),
      desc: t('about.value3.desc')
    },
    {
      icon: 'fa-solid fa-users',
      title: t('about.value4.title'),
      desc: t('about.value4.desc')
    }
  ];

  const stats = [
    { value: '5+', label: t('about.stat1.label') },
    { value: '5', label: t('about.stat2.label') },
    { value: '24/7', label: t('about.stat3.label') }
  ];

  return (
    <section className="about-section" id="about">
      <div className="about-glow-blob blob-about-1" />
      <div className="about-glow-blob blob-about-2" />

      <div className="section-header">
        <h2 className="section-title">{t('about.title')}</h2>
        <p className="section-subtitle">{t('about.subtitle')}</p>
        <span className="section-line" />
      </div>

      <div className="about-container">
        <div className="about-hero">
          <motion.div
            className="about-hero-text"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <span className="about-tag">{t('about.tag')}</span>
            <h3 className="about-mission">{t('about.lead')}</h3>
            <p className="about-story-text">{t('about.story')}</p>
          </motion.div>

          <motion.div
            className="about-hero-visual"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <GlassCard className="about-stats-card" hoverEffect={true}>
              <div className="about-stats-grid">
                {stats.map((stat, index) => (
                  <div className="about-stat-item" key={index}>
                    <span className="about-stat-value">{stat.value}</span>
                    <span className="about-stat-label">{stat.label}</span>
                  </div>
                ))}
              </div>
              <div className="about-stats-footer">
                <i className="fas fa-paper-plane"></i>
                <span>Telegram PRIME</span>
              </div>
            </GlassCard>
          </motion.div>
        </div>

        <div className="about-values-grid">
          {values.map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <GlassCard className="about-value-card" hoverEffect={true}>
                <div className="about-value-icon">
                  <i className={value.icon}></i>
                </div>
                <h3 className="about-value-title">{value.title}</h3>
                <p className="about-value-desc">{value.desc}</p>
              </GlassCard>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="about-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <GlassCard className="about-cta-card" hoverEffect={true}>
            <div className="about-cta-content">
              <h3>{t('about.ctaTitle')}</h3>
              <p>{t('about.ctaText')}</p>
            </div>
            <a
              href="mailto:haktung986@gmail.com"
              className="about-cta-btn"
            >
              <i className="fas fa-envelope mr-2"></i>
              {t('about.ctaButton')}
            </a>
          </GlassCard>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutUs;
